// extracted by mini-css-extract-plugin
export default {"text":"Footer_text__O5trc","linkWrapper":"Footer_linkWrapper__7tUJe","link":"Footer_link__biQjb","footer":"Footer_footer__iPIKy"};